import {useContext} from 'react';
import {useParams, useRouteMatch} from 'react-router-dom';
import {SeniorRelationshipInvitesHistory} from '../../../../../../../components/senior-relationship-invites-history/senior-relationship-invites-history';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';
import {CaregiverMode} from '../../../../../../../enums';

export default function SeniorInvitesHistorySystemAdministratorOfficeScreen() {
  let {id}: {id: string} = useParams();
  const officeContext: OfficeContextType = useContext(OfficeContext);
  let {url} = useRouteMatch();

  return (
    <SeniorRelationshipInvitesHistory
      seniorId={id || ''}
      seniorName={officeContext.state.userForm?.user.name || ''}
      inviteCaregiverUrl={url.replace('/invites', '/invite')}
      url={url}
      caregiverMode={CaregiverMode.SystemAdministrator}
    />
  );
}
